import { AbstractOperationMessage } from "./abstractOperationMessage"

export class OrderOperationMessage extends AbstractOperationMessage {

}